module.exports = __webpack_public_path__ + "static/happy_03-56ab546b466c7bf98e695512b16eef68.jpeg";